export default class Dialogue extends BaseComponent {
    functions() {
        return {
            setDialogHeader: text => this.find('.dialogue-header').text(text),
            setDialogText: this.setText.bind(this),
            showDialog: name => this.show(name),
            hideDialog: this.hide.bind(this),
            completeDialogLoading: () => this.find('.loading').removeClass('loading')
        }
    }

    setTitle(text) {
        this.find('.title-text').html(text + '<div class=title-triangle></div>')
    }

    setText(text) {
        this.find('.dialogue-text').html(text)
    }

    show(name) {
        if (name && this.options.name != name) {
            return;
        }
        this.find('.dialogue-container').removeAttr('hidden');
    }

    hide() {
        this.find('.dialogue-container').attr('hidden', 'hidden');
    }

    handleOk() {
        if (_functions.handleDialogOk) {
            _functions.handleDialogOk(this.options.name);
        }
        this.hide();
    }

    handleCancel() {
        if (_functions.handleDialogCancel) {
            _functions.handleDialogCancel(this.options.name);
        }
        this.hide();
    }
}